import englishProficiencyJson from '../../../assets/translations/english-proficiency.json'

export const englishProficiencyContent: any = englishProficiencyJson
